import hasUsedAllClauseTypesInSection from './helpers/hasUsedAllClauseTypesInSection';
import store from '../store/store';
import { getGuid } from 'owa-guid';
import { action } from 'satcheljs/lib/legacy';
var addNewClause = action('addNewClause')(function addNewClause(sectionType, clauseType, clauseValue) {
    // If user has maxed out on clause types (they have used every possible clause type already), then it's a no-op
    if (hasUsedAllClauseTypesInSection(sectionType)) {
        return;
    }
    var newClauseId = getGuid();
    if (sectionType == 'conditional') {
        store.inboxRulesEditState.conditionalClauseIds.push(newClauseId);
    }
    else if (sectionType == 'action') {
        store.inboxRulesEditState.actionClauseIds.push(newClauseId);
    }
    else if (sectionType == 'exception') {
        store.inboxRulesEditState.exceptionClauseIds.push(newClauseId);
    }
    else {
        throw new Error('Cannot add a clause id to a section that does not exists');
    }
    store.inboxRulesEditState.clauseMap.set(newClauseId, {
        clauseType: clauseType,
        clauseValue: clauseValue,
    });
});
export default addNewClause;
//# sourceMappingURL=addNewClause.js.map